import { useEffect, useState } from "react";

function useThirdPartyCookieSupport() {
  const [cookiesAllowed, setCookiesAllowed] = useState(true);

  useEffect(() => {
    try {
      document.cookie = "test_third_party_cookie=1; SameSite=None; Secure";
      const isSet = document.cookie.includes("test_third_party_cookie=1");
      setCookiesAllowed(isSet);
    } catch (e) {
      setCookiesAllowed(false);
    }
  }, []);

  return cookiesAllowed;
}

export default useThirdPartyCookieSupport;
